import React from 'react';

import pathImg1 from '../../assets/images/path.svg';
import { observer } from 'mobx-react-lite';
import pathImg2 from '../../assets/images/path-2.svg';
import { useRouletteDoBetValidation } from '../../hooks/useRouletteDoBetValidation';
import { doChipStore } from '../../store/doChipStore';
import { CombinationTypes, BetType } from '../../enums/tableNumbers';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store';

const SnakesBetType = observer(({ handleMouseMove, handleMouseLeave, isBetShop = false }) => {
  const { selectedChip } = doChipStore;
  const { activeFreeBet } = freeBetStore;
  const { handleDoBetInCombination } = useRouletteDoBetValidation();

  const handleDoChip = (e) => {
    const valueType = e.target.getAttribute('data');
    const model = CombinationTypes[valueType];
    if (model) {
      if (selectedChip) {
        handleDoBetInCombination(model, selectedChip, valueType);
      }
    }
  };

  return (
    <div className={`versions-btns-wrp ${activeFreeBet.id ? 'disabled' : ''}`} onMouseMove={handleMouseMove}
         onMouseLeave={handleMouseLeave}>
      <div className="ver-btn-cont">
        <div className="ver-btn active" data={BetType.Red_Snake} onClick={handleDoChip}>
          <img src={pathImg2} alt="" data={BetType.Red_Snake}/>
        </div>
        <div className="ver-btn" data={BetType.Black_Snake} onClick={handleDoChip}>
          <img src={pathImg2} alt="" data={BetType.Black_Snake}/>
        </div>
      </div>
      {isBetShop ? null : (
        <div className="ver-btn-cont">
          <div className="ver-btn active" data={BetType.Red_Pairs} onClick={handleDoChip}>
            <img src={pathImg1} alt="" data={BetType.Red_Pairs}/>
          </div>
          <div className="ver-btn" data={BetType.Black_Pairs} onClick={handleDoChip}>
            <img src={pathImg1} alt="" data={BetType.Black_Pairs}/>
          </div>
        </div>
      )}
    </div>
  );
});
export default SnakesBetType;
